import { render, staticRenderFns } from "./SlackSuccessPage.vue?vue&type=template&id=f381b662&scoped=true"
import script from "./SlackSuccessPage.vue?vue&type=script&lang=ts"
export * from "./SlackSuccessPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f381b662",
  null
  
)

export default component.exports